import type { RangeValue } from "@sellar-io/components";
import type { DiscoveryV2ListParameterModifierType } from "@sellar-io/api-v2/types";

export const getRangeLabel = (
  range: RangeValue,
  format: (value: number) => string,
) => {
  switch (range.type) {
    case "minimum":
      return `${format(range.low)}+`;
    case "maximum":
      return `Under ${format(range.high)}`;
    case "between":
      return `${format(range.low)} - ${format(range.high)}`;
  }
};

export const buildRangeQuery = (
  type: "price" | "abv",
  range: RangeValue | undefined,
): DiscoveryV2ListParameterModifierType[] => {
  if (!range) {
    return [];
  }
  switch (range.type) {
    case "minimum":
      return [{ type, modifier: "GREATER_THAN_OR_EQUAL", value: range.low }];
    case "maximum":
      return [{ type, modifier: "LESS_THAN", value: range.high }];
    case "between":
      return [
        {
          type,
          modifier: "BETWEEN",
          value: { low: range.low, high: range.high },
        },
      ];
  }
};
